module.exports = __webpack_public_path__ + "img/bmcl_gallery4.4650651c.jpg";